import { Box, Container, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import ReactTable from 'src/theme/overrides/reactTable';
import InvoicesList from './InvoicesList';

export default function Invoices(props) {
  const columns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Age',
      accessor: 'age',
      sortType: 'basic', // Enable sorting for this column
    },
  ];
  const data = [
    { id: 1, name: 'John Doe', age: 28 },
    { id: 2, name: 'Jane Doe', age: 35 },
  ];
  return (
    <>
      <Helmet>
        <title> Invoices | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Invoices
          </Typography>
        </Stack>
        <Box
          p={4}
          component={Paper}
          boxShadow={3}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        >
          <InvoicesList
            setMessage={props.setMessage}
            setLoading={props.setLoading}
            setSaved={props.setSaved}
            setOpen={props.setOpen}
          />
        </Box>
      </Container>
    </>
  );
}
